var o = "_icon_1q1xv_1",
  s = "_message_moai9_3",
  e = "_typeIcon_moai9_17",
  c = "_close_moai9_22",
  _ = {
    icon: o,
    message: s,
    typeIcon: e,
    close: c
  };
export { c as close, _ as default, o as icon, s as message, e as typeIcon };